import React, { useEffect } from 'react';
import { Styles } from './style';
import Contacts from './Contacts';
import TypeList from './TypeList';
import Rights from './Rights';
import { useMetadataStore } from '@stores/Metadata/Metadata';

const Footer = () => {
  const { configuracoes, fetchConfiguracoes } = useMetadataStore();

  useEffect(() => {
    fetchConfiguracoes();
  }, [fetchConfiguracoes]);

  return (
    <>
      <Styles.FooterContainer>
        <Styles.FooterContent>
          <Contacts
            nomeEmpresa={configuracoes?.nome_empresa ?? undefined}
            endereco={configuracoes?.endereco_empresa ?? undefined}
            whatsapp={configuracoes?.whatsapp_empresa ?? undefined}
            email={configuracoes?.email_empresa ?? undefined}
          />
          <TypeList />
          <Rights
            nomeEmpresa={configuracoes?.nome_empresa ?? undefined}
            logoUri={configuracoes?.footer_logo_uri ?? undefined}
            creci={configuracoes?.creci ?? undefined}
          />
        </Styles.FooterContent>
      </Styles.FooterContainer>
    </>
  );
};

export default Footer;
